import { useEffect, useState } from "react";
import { crearComentario, listarComentarios, me } from "../api";
import "./CommentsThread.css";

export default function CommentsThread({ patientId }) {
  const [user, setUser] = useState(null);
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => { me().then(r => setUser(r.user)); }, []);
  const load = async () => {
    try {
      setLoading(true);
      const rows = await listarComentarios(patientId);
      setItems(rows);
    } catch (e) {
      setMsg(e.message || "No se pudieron cargar comentarios");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { if (patientId) load(); }, [patientId]);

  const submit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setMsg("");
    try {
      await crearComentario(patientId, text.trim());
      setText("");
      load();
    } catch (e2) {
      setMsg(e2.message || "No se pudo guardar");
    }
  };

  const roleLabel = (r) => r === 'admin' ? 'Admin' : r === 'psicologa' ? 'Psicología' : 'Logopedia';

  return (
    <div className="ct-wrap">
      <h3>Comentarios</h3>
      {msg && <div className="ct-msg">{msg}</div>}

      <form onSubmit={submit} className="ct-form">
        <textarea
          rows={3}
          placeholder="Escribe un comentario…"
          value={text}
          onChange={(e)=>setText(e.target.value)}
        />
        <div className="ct-actions">
          <button disabled={!text.trim()}>Añadir comentario</button>
        </div>
      </form>

      <div className="ct-list">
        {loading && <div className="ct-muted">Cargando…</div>}
        {!loading && items.length === 0 && (
          <div className="ct-muted">Sin comentarios aún</div>
        )}
        {items.map(c => (
          <div key={c.id} className="ct-item">
            <div className="ct-head">
              <span className="ct-author">{c.author || 'Usuario'}</span>
              <span className="ct-role">{roleLabel(c.role)}</span>
              <span className="ct-date">{new Date(c.created_at).toLocaleString()}</span>
            </div>
            <div className="ct-body">{c.body}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
